import { useAuthStore } from '@/lib/store/authStore';

/**
 * Support-only tenants (e.g. "heybay") get a stripped-down dashboard: the sidebar
 * shows ONLY the Help Center (ศูนย์ช่วยเหลือ), every app/ERP module is hidden, and
 * all non-support routes are redirected to /support.
 *
 * The flag is set on the Control Plane Tenant doc and delivered via `my_access`
 * (see authStore.fetchAndStoreAppAccess). Defaults to `false` so normal tenants
 * are never restricted, including during the brief window before my_access resolves.
 */
export function useSupportOnly(): boolean {
  return useAuthStore((s) => s.supportOnly);
}
